/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte Framework package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

import Vue from "vue";

import { initializeApp } from "./app";
import { registerServiceWorker } from "./service-worker";

import * as Dashboard from "./dashboard";
import * as Login from "./login";
import * as Profile from "./profile";

import "../scss/main.scss";

Object.values(Dashboard).forEach(c => Vue.component(c.name, c));
Object.values(Login).forEach(c => Vue.component(c.name, c));
Object.values(Profile).forEach(c => Vue.component(c.name, c));

initializeApp()
	.then(() => registerServiceWorker());
